export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 64;

/**
 * MUI breakpoint at which the persistent sidebar collapses into a temporary
 * overlay drawer.
 *
 * Decision (S5): The HTML mockup collapses the sidebar at 768px, but the
 * React shell keeps MUI's `md` breakpoint (900px). The wider threshold is
 * intentional and preferred for usability: between 768px and 900px a
 * permanent 260px sidebar leaves too little room for the content area on
 * tablets in landscape, and the temporary-drawer experience reads better
 * across that range. This also matches MUI's canonical "sidebar below md"
 * pattern, so the breakpoint stays consistent with the rest of the app.
 */
export const SIDEBAR_COLLAPSE_BREAKPOINT = "md" as const;

/**
 * Sidebar width transition (S9).
 *
 * The mockup shell uses `transition: width 0.2s ease`. The previous React
 * implementation used MUI's `easing.sharp` + `duration.standard` (300ms),
 * which felt slower than the mockup. Standardise on 200ms ease for every
 * sidebar width animation.
 */
export const SIDEBAR_TRANSITION = "width 200ms ease";

/**
 * Sidebar paper transition — width and (temporary drawer) transform, both
 * at 200ms ease to match {@link SIDEBAR_TRANSITION}.
 */
export const SIDEBAR_PAPER_TRANSITION =
  "width 200ms ease, transform 200ms ease";

/** Maximum width for centered page content on wide screens (S2). */
export const CONTENT_MAX_WIDTH = 1280;
